import { CommonModule } from '@angular/common';
import {
  Component,
  inject,
  input,
  signal,
  type InputSignal,
} from '@angular/core';
import { fileTypeIcon } from '@app/helpers/fileDownload';
import type { FileInfo } from '@app/models/document.model';
import { DownloadService } from '@app/services/file/download.service';

@Component({
  selector: 'app-attachment',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './attachment.component.html',
  styleUrl: './attachment.component.scss',
})
export class AttachmentComponent {
  private readonly download = inject(DownloadService);

  file: InputSignal<FileInfo | null> = input<FileInfo | null>(null);
  readonly isDownloading = signal(false);

  iconClass(): string {
    return fileTypeIcon(this.file());
  }

  onDownload(): void {
    const file = this.file();
    if (!file?.id) return;
    this.isDownloading.set(true);
    this.download.downloadFileById(file.id, file.name ?? 'document').subscribe({
      complete: () => this.isDownloading.set(false),
      error: () => this.isDownloading.set(false),
    });
  }
}
